import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { EmploymentInfo } from '@models/profileConfiguration/model';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs';
import { EmploymentInfoState, EmploymentInfoStore } from './employment-info.store';

@Injectable({
  providedIn: 'root',
})
export class EmploymentInfoQuery extends QueryEntity<EmploymentInfoState> {
  protected store: EmploymentInfoStore;

  constructor() {
    const store = inject(EmploymentInfoStore);

    super(store);

    this.store = store;
  }

  public employmentInfo$ = this.store.getValue();

  public selectAllWhenLoaded(): Observable<EmploymentInfo[]> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectAll())
    );
  }
}
